/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react'

import { clsx } from 'clsx'

import { Label } from '@buffer-mono/popcorn'

import { AIAssistantContext } from '~publish/legacy/ai/components/AIAssistant/AIAssistant'
import { ACTIONS } from '~publish/legacy/ai/components/AIAssistant/AIAssistant.constants'
import { GenerationResult } from '~publish/legacy/ai/components/AIAssistant/components/GenerationResult'
import { Prompt } from '~publish/legacy/ai/components/AIAssistant/components/Prompt'
import { useContentGeneration } from '~publish/legacy/ai/hooks/useContentGeneration'

import styles from './AIRefine.module.css'

import type { JSX } from 'react'

/**
 *
 */
function AIRefine({
  initAction,
  initPrompt,
  onClear,
}: {
  initAction: string | null
  initPrompt: string | null
  onClear: () => void
}): JSX.Element | null {
  const [expanded, setExpanded] = React.useState<boolean>(false)

  const { channel } = React.useContext(AIAssistantContext)

  const { generateContent } = useContentGeneration()

  React.useEffect(() => {
    onGenerateContent()
  }, [])

  const onGenerateContent = (): void => {
    if (!initAction || !initPrompt) return

    generateContent({
      prompt: initPrompt,
      action: initAction,
      service: channel,
      tone: null,
    })
  }

  const onToggle = (): void => {
    setExpanded(!expanded)
  }

  const actionConfig = Object.entries(ACTIONS).find(
    ([actionKey]) => actionKey === initAction,
  )?.[1]

  return initPrompt ? (
    <div className={styles.wrapper}>
      <div
        className={clsx(styles.promptWrapper, expanded && styles.withBorder)}
      >
        {actionConfig && (
          <Label data-test-id={`ai-assistant-refine-title`}>
            {actionConfig.label}:
          </Label>
        )}
        <Prompt
          prompt={initPrompt}
          expanded={expanded}
          onToggle={onToggle}
          onClear={onClear}
          lines={2}
          withBackground
        />
      </div>
      <GenerationResult disabled={expanded} />
    </div>
  ) : null
}

export { AIRefine }
